// extracted by mini-css-extract-plugin
export default {"base":"EditChangelog_base__RVa-h","label":"EditChangelog_label__dOWaf","field":"EditChangelog_field__lwh3N"};